import React from 'react';

export const PlayArrowIcon = () => {
    return (
        <svg style={{ fontSize: 40, fill: '#fff' }} className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M8 5v14l11-7z"></path>
        </svg>
    )
}
